import React from 'react'

const CheckHotlineContext = React.createContext({})

export default CheckHotlineContext